module.exports = __webpack_public_path__ + "img/pet.d77f9882.png";